// extracted by mini-css-extract-plugin
export default {"ScreenMDMin":"(min-width: 992px)","resetButton":"G16714d","arrow":"G42e37f G16714d","left":"G72dd56","right":"G436d99"};